import { render, staticRenderFns } from "./ContentDropdown.vue?vue&type=template&id=308fcad9&scoped=true&"
import script from "./ContentDropdown.vue?vue&type=script&lang=js&"
export * from "./ContentDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ContentDropdown.vue?vue&type=style&index=0&id=308fcad9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308fcad9",
  null
  
)

export default component.exports